import { motion } from "framer-motion";
import { Reveal, MaskedLine } from "@/components/Reveal";
import { scrollToId } from "@/utils/scroll";
import { inr, PRODUCT } from "@/context/CartContext";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="bg-pink text-black py-28 sm:py-40 overflow-hidden relative">
      <div className="mx-auto max-w-7xl px-5 sm:px-10 text-center">
        <h2 className="font-display leading-[0.88]" data-sound="guitar" data-cursor="shutup">
          <MaskedLine inView className="text-[clamp(3rem,11vw,10rem)]">
            THEY SAID
          </MaskedLine>
          <MaskedLine inView delay={0.08} className="text-[clamp(3rem,11vw,10rem)]">
            SHUT UP.
          </MaskedLine>
          <MaskedLine inView delay={0.2} className="text-[clamp(1.6rem,5vw,4rem)] mt-8">
            WE SAID.
          </MaskedLine>
          <MaskedLine inView delay={0.3} className="text-[clamp(2.6rem,9vw,8rem)]">
            <span className="stroke-black">MAKE IT</span> <span className="text-paper">LOUDER.</span>
          </MaskedLine>
        </h2>

        <Reveal delay={0.35} className="mt-14">
          <p className="font-sans font-bold text-sm sm:text-base tracking-[0.3em]">{PRODUCT.name}</p>
          <p className="font-sans font-bold text-2xl sm:text-3xl mt-2">{inr(PRODUCT.price)}</p>
          <p className="font-sans text-black/60 text-xs tracking-[0.3em] mt-2">ONLY 200 PIECES</p>
        </Reveal>

        <Reveal delay={0.45}>
          <motion.button
            data-testid="final-buy-button"
            data-cursor="shutup"
            onClick={() => scrollToId("#product")}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            className="group mt-10 font-sans bg-black text-paper font-bold tracking-[0.12em] text-base sm:text-xl px-10 sm:px-14 py-5 sm:py-6 hover:bg-ink border-2 border-black shadow-[8px_8px_0_#0D0D0D]"
          >
            BUY THE SHUTUP T-SHIRT{" "}
            <span className="inline-block transition-transform group-hover:translate-x-2">→</span>
          </motion.button>
        </Reveal>
      </div>
    </section>
  );
}
